"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sphere = void 0;
const gl_matrix_1 = require("gl-matrix");
class Sphere {
    // #region Constructors (1)
    constructor(_center = gl_matrix_1.vec3.create(), _radius = 0) {
        this._center = _center;
        this._radius = _radius;
    }
    // #endregion Constructors (1)
    // #region Public Accessors (4)
    get center() {
        return this._center;
    }
    set center(value) {
        this._center = value;
    }
    get radius() {
        return this._radius;
    }
    set radius(value) {
        this._radius = value;
    }
    // #endregion Public Accessors (4)
    // #region Public Methods (4)
    applyMatrix(matrix) {
        this._center = gl_matrix_1.vec3.transformMat4(gl_matrix_1.vec3.create(), this._center, matrix);
        const scaleXSq = matrix[0] * matrix[0] +
            matrix[1] * matrix[1] +
            matrix[2] * matrix[2];
        const scaleYSq = matrix[4] * matrix[4] +
            matrix[5] * matrix[5] +
            matrix[6] * matrix[6];
        const scaleZSq = matrix[8] * matrix[8] +
            matrix[9] * matrix[9] +
            matrix[10] * matrix[10];
        const maxScaleOnAxis = Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
        this.radius = this.radius * maxScaleOnAxis;
        return this;
    }
    clone() {
        return new Sphere(gl_matrix_1.vec3.clone(this._center), this._radius);
    }
    containsPoint(point) {
        return (gl_matrix_1.vec3.squaredDistance(point, this.center) <=
            this.radius * this.radius);
    }
    clampPoint(point) {
        return point;
    }
    intersect(origin, direction) {
        // vector from ray origin to sphere center
        const rayToSphere = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), this.center, origin);
        // project rayToSphere onto direction
        const projection = gl_matrix_1.vec3.dot(rayToSphere, direction);
        // distance from sphere center to projection
        const distanceToProjection = gl_matrix_1.vec3.squaredDistance(rayToSphere, gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), direction, gl_matrix_1.vec3.fromValues(projection, projection, projection)));
        // check if the distance to projection is less than the radius
        if (distanceToProjection <= this.radius * this.radius) {
            // calculate the distance from the origin to the intersection point
            const distanceToIntersection = Math.sqrt(this.radius * this.radius - distanceToProjection);
            return projection - distanceToIntersection;
        }
        // if there is no intersection, return null
        return null;
    }
    intersects(origin, direction) {
        // vector from ray origin to sphere center
        const rayToSphere = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), this.center, origin);
        // project rayToSphere onto direction
        const projection = gl_matrix_1.vec3.dot(rayToSphere, direction);
        // distance from sphere center to projection
        const distanceToProjection = gl_matrix_1.vec3.squaredDistance(rayToSphere, gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), direction, gl_matrix_1.vec3.fromValues(projection, projection, projection)));
        return distanceToProjection <= this.radius * this.radius;
    }
    setFromBox(box) {
        gl_matrix_1.vec3.add(this.center, box.min, box.max);
        gl_matrix_1.vec3.scale(this.center, this.center, 0.5);
        this.radius = gl_matrix_1.vec3.dist(box.min, box.max) * 0.5;
        return this;
    }
    reset() {
        this._center = gl_matrix_1.vec3.create();
        this._radius = 0;
    }
}
exports.Sphere = Sphere;
//# sourceMappingURL=Sphere.js.map